'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevronright, SvgHamburger } from '@common/icon';
import { cn } from '@core/utils';
import * as RadixDropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
interface CategoryItem {
  id: string;
  label: string;
  href?: string;
  children?: CategoryItem[];
}
interface CategoryDropdownProps {
  categories: CategoryItem[];
  className?: string;
}

// 확장형 메뉴 아이템 컴포넌트
const ExpandableMenuItem = t0 => {
  const $ = _c(14);
  const {
    item,
    initialSelectedChild,
    onClose
  } = t0;
  const pathname = usePathname();
  const [selectedChild, setSelectedChild] = useState(initialSelectedChild || null);
  let t1;
  if ($[0] !== item.children || $[1] !== onClose || $[2] !== pathname || $[3] !== selectedChild?.id) {
    t1 = item.children?.map(child => {
      if (child.href) {
        return <LinkItem key={child.id} href={child.href} label={child.label} isSelected={pathname === child.href} onClick={onClose} />;
      }
      return <GroupItem key={child.id} isSelected={selectedChild?.id === child.id} label={child.label} onClick={() => {
        if (selectedChild?.id === child.id) {
          return;
        }
        setSelectedChild(child);
      }} />;
    });
    $[0] = item.children;
    $[1] = onClose;
    $[2] = pathname;
    $[3] = selectedChild?.id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="min-w-160 py-12 pl-12">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== onClose || $[8] !== pathname || $[9] !== selectedChild) {
    t3 = selectedChild && <><div className="mx-16 min-h-100 w-1 self-stretch bg-Gray-200" /><div className="max-h-[27.375rem] min-w-160 overflow-y-auto py-12 pr-12">{selectedChild.children?.filter(_temp).map(grandChild_0 => <LinkItem isSelected={pathname === grandChild_0.href} key={grandChild_0.id} href={grandChild_0.href} label={grandChild_0.label} onClick={onClose} />)}</div></>;
    $[7] = onClose;
    $[8] = pathname;
    $[9] = selectedChild;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <div className="flex">{t2}{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};

// 메인 카테고리 드롭다운 컴포넌트
export const CategoryDropdown = t0 => {
  const $ = _c(20);
  const {
    categories,
    className
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [initialSelectedChild, setInitialSelectedChild] = useState(null);
  let t1;
  if ($[0] !== categories[0] || $[1] !== categories.length) {
    t1 = opened => {
      setIsOpen(opened);
      if (opened && categories.length > 0 && categories[0].children && categories[0].children.length > 0) {
        setInitialSelectedChild(categories[0].children[0]);
      } else {
        if (!opened) {
          setInitialSelectedChild(null);
        }
      }
    };
    $[0] = categories[0];
    $[1] = categories.length;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== className) {
    t2 = cn("flex min-h-56 cursor-pointer items-center gap-8 border-none bg-transparent px-24 py-0 outline-none", "font-700 text-Gray-800 typo-body3", className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SvgHamburger className="size-20 text-Gray-800" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <RadixDropdownMenuPrimitive.Trigger className={t2}>{t3}카테고리</RadixDropdownMenuPrimitive.Trigger>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== categories || $[9] !== initialSelectedChild) {
    let t6;
    if ($[11] !== initialSelectedChild) {
      t6 = (category, index) => <ExpandableMenuItem key={category.id} item={category} initialSelectedChild={index === 0 ? initialSelectedChild : null} onClose={() => setIsOpen(false)} />;
      $[11] = initialSelectedChild;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t5 = categories.map(t6);
    $[8] = categories;
    $[9] = initialSelectedChild;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <RadixDropdownMenuPrimitive.Portal><RadixDropdownMenuPrimitive.Content className="z-10 min-w-240 overflow-y-auto rounded-b-small border-1 border-Gray-300 bg-Gray-white shadow-xl" side="bottom" align="start" sideOffset={0}>{t5}</RadixDropdownMenuPrimitive.Content></RadixDropdownMenuPrimitive.Portal>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isOpen || $[16] !== t1 || $[17] !== t4 || $[18] !== t6) {
    t7 = <RadixDropdownMenuPrimitive.Root modal={false} open={isOpen} onOpenChange={t1}>{t4}{t6}</RadixDropdownMenuPrimitive.Root>;
    $[15] = isOpen;
    $[16] = t1;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
const LinkItem = t0 => {
  const $ = _c(12);
  const {
    isSelected,
    href,
    label,
    onClick
  } = t0;
  let t1;
  if ($[0] !== isSelected) {
    t1 = cn("flex cursor-pointer items-center justify-between rounded-xsmall px-16 py-12 text-Gray-550 hover:text-Gray-black", {
      "bg-Gray-100": isSelected
    });
    $[0] = isSelected;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isSelected) {
    t2 = cn("font-400 text-inherit typo-body3", {
      "text-Gray-black font-700": isSelected
    });
    $[2] = isSelected;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label || $[5] !== t2) {
    t3 = <span className={t2}>{label}</span>;
    $[4] = label;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== href || $[8] !== onClick || $[9] !== t1 || $[10] !== t3) {
    t4 = <CustomLink className={t1} href={href} onClick={onClick}>{t3}</CustomLink>;
    $[7] = href;
    $[8] = onClick;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
const GroupItem = t0 => {
  const $ = _c(14);
  const {
    isSelected,
    label,
    onClick
  } = t0;
  let t1;
  if ($[0] !== isSelected) {
    t1 = cn("flex cursor-pointer items-center justify-between rounded-xsmall px-16 py-12 text-Gray-550 hover:text-Gray-black", {
      "bg-Gray-100": isSelected
    });
    $[0] = isSelected;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isSelected) {
    t2 = cn("font-400 text-inherit typo-body3", {
      "text-Gray-black font-700": isSelected
    });
    $[2] = isSelected;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label || $[5] !== t2) {
    t3 = <span className={t2}>{label}</span>;
    $[4] = label;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isSelected) {
    t4 = isSelected && <SvgChevronright className="size-20 text-Gray-black" />;
    $[7] = isSelected;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onClick || $[10] !== t1 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className={t1} onClick={onClick}>{t3}{t4}</div>;
    $[9] = onClick;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp(grandChild) {
  return grandChild.href;
}